import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { OrderEntry } from '@spartacus/cart/base/root';
import { QuickOrderItemComponent } from '@spartacus/cart/quick-order/components';
import { QuickOrderFacade } from '@spartacus/cart/quick-order/root';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { of } from 'rxjs';
import { catchError, finalize, first, switchMap, take, tap } from 'rxjs/operators';
import { GenMSRPPrice } from 'src/app/generac/models/product.model';
import { GenProductService } from 'src/app/generac/services/product.service';

@Component({
    selector: '[gen-quick-order-item], gen-quick-order-item',
    templateUrl: './quick-order-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenQuickOrderItemComponent extends QuickOrderItemComponent {
  override quantityControl: UntypedFormControl;
  netPrice: string;
  currency: string;
  noNetPrice: boolean;
  onHand: boolean;

  override get entry(): OrderEntry {
    return this._entry;
  }

  @Input('entry') override set entry(value: OrderEntry) {
    if (!value.product.minOrderQuantity) {
      value.product.minOrderQuantity = value.product.addToCartQtyMultiplier;
    }
    this._entry = value;
    this.quantityControl = new UntypedFormControl(this.entry.quantity, {
      updateOn: 'blur',
    });
    this.userAccount.get().pipe(
      switchMap(user => this.productService.getCPIPrice(user?.uid, value?.product)
        .pipe(
          take(1),
          tap((price: GenMSRPPrice) => {
            if (price) {
              if(price?.value == ""){
                this.noNetPrice = true;
              }
              this.netPrice = price.value;
              this.onHand = price.onHand;
              this.currency = price.currency;
              this.cd.markForCheck();
            }
          }),
          catchError(() => {
            this.noNetPrice = true;
            return of();
          }),
          finalize(() => {
            this.cd.markForCheck();
          })
        )
      ),
      first(),
    ).subscribe()
  }

  protected override _entry: OrderEntry;

  constructor(
    private productService: GenProductService,
    private userAccount: UserAccountFacade,
    protected override cd: ChangeDetectorRef,
    protected override quickOrderService: QuickOrderFacade
  ) {
    super(cd, quickOrderService);
  }
}
